import { IssueDevelopmentComponent } from './issue-development.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    component: IssueDevelopmentComponent
  },
  {
    path: ':id',
    component: IssueDevelopmentComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IssueDevelopmentRoutingModule { }
